import React from "react";
import {
  MDBSelect,
  MDBNotification,
  MDBInputGroup,
  MDBDatePicker,
  toast,
  MDBFormInline,
  MDBBadge,
  MDBAnimation,
  ToastContainer,
  MDBIcon,
  MDBDataTable,
  MDBAlert,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalFooter,
  MDBCard,
  MDBCardBody,
  MDBCardHeader,
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBInput,
  MDBBtn,
  MDBBtnGroup,
} from "mdbreact";
import Loader from "../../Components/Loader";
import { API_CONFIG, casaideas_credentials } from "../../Config/config-env.js";
import axios from "axios";

class externalForm02 extends React.Component {
  state = {
    id_producto: -1,
    mensaje: "",
    accion: "",
    executedTask: false,
    isDeleted: false,
    productQty: 1,
    productName: "",
    formButtons: {
      type: "",
      buttonsList: [],
    },
    SKUcode: "3212567000066",
    productPrice: 0,
    existingPreviousOrder: false,
    isExecuting: false,
    processing: "Procesando",
    costo_envio: 0,
    monto_real: "",
    monto_2: "",
    metodo_pago: "",
    metodo_pago_2: "",
    TRX: "",
    from_date: new Date(),
    descuento: 0,
    sub_total: 0,
    observation: "",
    motivo_no_entrega: "",

    motivos: [
      { text: "NO SE ENCUENTRA EN CASA", value: "NO SE ENCUENTRA EN CASA" },
      { text: "NO RESPONDE EL TELEFONO", value: "NO RESPONDE EL TELEFONO" },
      {
        text: "CLIENTE PIDIO RE-PROGRAMACION  PARA OTRO DIA",
        value: "CLIENTE PIDIO RE-PROGRAMACION  PARA OTRO DIA",
      },
      {
        text: "ERROR EN ENTREGA (PEDIDO NO CORRESPONDE AL CLIENTE)",
        value: "ERROR EN ENTREGA (PEDIDO NO CORRESPONDE AL CLIENTE)",
      },
      {
        text: "CLIENTE DETECTO FALLAS EN EL PRODUCTO SE RECHAZO LA ENTREGA",
        value: "CLIENTE DETECTO FALLAS EN EL PRODUCTO SE RECHAZO LA ENTREGA",
      },
      {
        text: "NO SE LLEGO  A TIEMPO ( FALLA MECANICA DE TRANSPORTE)",
        value: "NO SE LLEGO  A TIEMPO ( FALLA MECANICA DE TRANSPORTE)",
      },
      {
        text: "NO SE LLEGO A TIEMPO (MUCHA TRANCADERA)",
        value: "NO SE LLEGO A TIEMPO (MUCHA TRANCADERA)",
      },
      {
        text: "NO SE LLEGO A TIEMPO (DIRECCION DE ENTREGA LEJANA)",
        value: "NO SE LLEGO A TIEMPO (DIRECCION DE ENTREGA LEJANA)",
      },
      {
        text: "NO SE LLEGO A TIEMPO (DIRECCION DE ENTREGA INCORRECTA)",
        value: "NO SE LLEGO A TIEMPO (DIRECCION DE ENTREGA INCORRECTA)",
      },
    ],
    metodos: [],
    metodos_orig: [
      { text: "EFECTIVO", value: "EFECTIVO", checked: false },
      { text: "TARJETA ATC", value: "TARJETA ATC", checked: false },
      { text: "TARJETA LINKSER", value: "TARJETA LINKSER", checked: false },
      { text: "DEPOSITO", value: "DEPOSITO", checked: false },
      { text: "TODOTIX", value: "TODOTIX", checked: false },
       { text: "QR BCP", value: "QR BCP", checked: false },
      { text: "PAGO ALTERNATIVO", value: "PAGO ALTERNATIVO", checked: false },
      { text: "PAGO QR", value: "QR", checked: false },

      {
        text: "QR DINÁMICO LIBÉLULA",
        value: "QR DINÁMICO LIBÉLULA",
        checked: false,
      },

      {
        text: "LINEAS DE CRÉDITO IISA",
        value: "LINEAS DE CRÉDITO IISA",
        checked: false,
      },
    ],

    metodos2: [
      { text: "NINGUNO", value: "", checked: true },
      { text: "EFECTIVO", value: "EFECTIVO" },
      { text: "TARJETA ATC", value: "TARJETA ATC" },
      { text: "TARJETA LINKSER", value: "TARJETA LINKSER" },
      { text: "DEPOSITO", value: "DEPOSITO" },
      { text: "TODOTIX", value: "TODOTIX" },
       { text: "QR BCP", value: "QR BCP", checked: false },
      { text: "PAGO ALTERNATIVO", value: "PAGO ALTERNATIVO" },
      { text: "PAGO QR", value: "QR" },

      {
        text: "QR DINÁMICO LIBÉLULA",
        value: "QR DINÁMICO LIBÉLULA",
        checked: false,
      },

      {
        text: "LINEAS DE CRÉDITO IISA",
        value: "LINEAS DE CRÉDITO IISA",
        checked: false,
      },
    ],

    orders: [],
    WO_Id: "",
    isLoadedTable: false,
    loadingData: true,
    modal4: false,
    modal3: false,
    order_id: "",
    orderName: "",
    orderPrice: "Bs.50",
    orderQty: "1",
    customerName: "",
    customerAdd: "",
    customerZone: "",
    productMaxQty: 0,
    disabledAdd: true,
    formButtons: [],
    numero_factura: "",
    razon_social: "",
  };

  getPickerValueFrom = (value) => {
    this.setState({ from_date: value });
  };

  componentDidMount = () => {
    this.LoadTable();
  };

  changeHandler = (event) => {
    this.setState({ ...this.state, [event.target.name]: event.target.value });
  };

  selectHandler2 = (event) => {
    //console.log("dato"+event[0])
    if (event[0]) {
      this.setState({ ...this.state, metodo_pago_2: event[0] });
    } else {
      this.setState({ ...this.state, metodo_pago_2: "" });
    }

    if (event[0] == "") {
      this.setState({ ...this.state, metodo_pago_2: "", monto_2: "" });
    }
  };

  selectHandler1 = (event) => {
    if (event[0]) {
      this.setState({ ...this.state, metodo_pago: event[0] });
    } else {
      this.setState({ ...this.state, metodo_pago: "" });
    }
  };

  selectHandler3 = (event) => {
    if (event[0]) {
      this.setState({ ...this.state, motivo_no_entrega: event[0] });
    } else {
      this.setState({ ...this.state, motivo_no_entrega: "" });
    }
  };

  saveInoiceData = async (event) => {
    //console.log("change",this.state.payId);
    this.setState({ isExecuting: true });
    let url = API_CONFIG.xflowurl + "/engine-users/save-flow-field";
    await axios({
      url: url,
      method: "put",
      data: {
        WO_flowID: this.state.WO_Id,
        WO_TaskID: this.state.WO_TaskId,
        params: [
          { var: "numero_factura", value: this.state.numero_factura },
          { var: "TRX", value: this.state.TRX },
          { var: "razon_social", value: this.state.razon_social },
        ],
      },
      headers: {
          

        "Content-Type": "application/json",
        Authorization: "Bearer " + this.state.token,
      },
    })
      .then((response) => response.data)
      .then(async (data) => {
        console.log(data);
        if (data.status) {
          url =
            API_CONFIG.xflowurl + "/customcomponents/update/resumen_ordenes";
          await axios({
            url: url,
            method: "put",
            data: {
              ID_PEDIDO: this.state.order_id,
              TRX: this.state.TRX,
              NROFACTURA: this.state.numero_factura,
              partial: true,
            },
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.state.token,
            },
          })
            .then((response) => response.data)
            .then((data) => {
              console.log(data);
              if (data.status) {
                toast.success("OK, datos guardados correctamente", {
                  closeButton: true,
                });
              } else {
                toast.error("NOK, error guardando datos, intente nuevamente", {
                  closeButton: true,
                });
              }
            });
        } else {
          toast.error("NOK, error guardando datos, intente nuevamente", {
            closeButton: true,
          });
        }
      });

    this.setState({ isExecuting: false });
  };

  LoadTable = async () => {
    let params = new URLSearchParams(this.props.location.search);
    let token = params.get("token");
    let WO_Id = params.get("wfpflowid");
    let WO_TaskId = params.get("wfptaskid");
    let officecode = params.get("officecode");
    let options = params.get("options") ? params.get("options").split(",") : [];
    var order_id = 0;
    var customer_id = 0;
    var nombre_cliente = "";
    var pedido_modificado = "";
    var costo_envio = "";
    var descuento = "";
    var direccion_1 = "";
    var zona = "";
    var pedido_parcial = "";
    var mixed_skus = [];
    var flowcode;
    var formButtons = [];
    var metodo_pago = "";
    var monto_total = "";
    var sub_total = "";
    for (let o in options) {
      formButtons.push({ optioncode: "op" + o, optionname: options[o] });
    }

    this.setState({
      isLoadedTable: false,
      WO_Id: WO_Id,
      WO_TaskId: WO_TaskId,
      loadingData: true,
      token: token,
      formButtons: formButtons,
    });

    await axios({
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      url: API_CONFIG.xflowurl + "/engine-users/get-task-details",
      //url : "http://localhost:4042/api/v1"+"/engine-users/get-task-details",
      data: {
        wfptaskid: WO_TaskId,
      },
      method: "post",
    })
      .then((response) => response.data)
      .then((data) => {
        flowcode = data.task.FLOWCODE;
        console.log(flowcode);
        if (flowcode === "flowBolCI08") {
          this.setState({
            validaFactura: true,
          });
        }
        if (data.status) {
          for (let v in data.flowvars) {
            let flowVar = data.flowvars[v];
            if (flowVar.VARNAME === "order_id") {
              order_id = flowVar.VARVALUE;
            }
            if (flowVar.VARNAME === "customer_id") {
              customer_id = flowVar.VARVALUE;
            }
            if (flowVar.VARNAME === "nombre_cliente") {
              nombre_cliente = flowVar.VARVALUE;
            }
            if (flowVar.VARNAME === "pedido_modificado") {
              pedido_modificado = flowVar.VARVALUE;
            }
            if (flowVar.VARNAME === "shipping_cost") {
              costo_envio = flowVar.VARVALUE;
            }
            if (flowVar.VARNAME === "discount") {
              descuento = flowVar.VARVALUE;
            }
            if (flowVar.VARNAME === "direccion_1") {
              direccion_1 = flowVar.VARVALUE;
            }
            if (flowVar.VARNAME === "zona") {
              zona = flowVar.VARVALUE;
            }
            if (flowVar.VARNAME === "pedido_parcial") {
              pedido_parcial = flowVar.VARVALUE;
            }
            if (flowVar.VARNAME === "metodo_pago") {
              metodo_pago = flowVar.VARVALUE;
            }
            if (flowVar.VARNAME === "monto_total") {
              monto_total = flowVar.VARVALUE;
            }
            if (flowVar.VARNAME === "subtotal") {
              sub_total = flowVar.VARVALUE;
            }
            if (flowVar.VARNAME === "mixed_skus") {
              try {
                mixed_skus = JSON.parse(flowVar.VARVALUE);
              } catch (ex) {
                console.log("EX", ex);
              }
            }
            this.setState({ [flowVar.VARNAME]: flowVar.VARVALUE });
          }
        }
      });

    var metodos = this.state.metodos_orig;
    for (var k in metodos) {
      let obj = metodos[k];
      if (obj["value"] == metodo_pago) {
        obj["checked"] = true;
      }
    }

    var fcosto_envio = costo_envio ? parseFloat(costo_envio, 2).toFixed(2) : 0;
    var fdescuento = descuento ? parseFloat(descuento, 2).toFixed(2) : 0;
    var fsub_total = sub_total ? parseFloat(sub_total, 2).toFixed(2) : 0;
    /*
    console.log("metodo_pago", metodo_pago);
    console.log("monto_total", monto_total);
    console.log("sub_total", sub_total);
    console.log("fcosto_envio", fcosto_envio);
*/
    this.setState({
      ...this.state,
      metodos: metodos,
      metodo_pago: metodo_pago,
      monto_total: monto_total,
      descuento: fdescuento,
      costo_envio: fcosto_envio,
      sub_total: fsub_total,
    });
    if (metodo_pago === "TODOTIX" || metodo_pago === "QR BCP") {
      this.setState({ monto_real: monto_total });
    }

    //let idTask = this.props.match.params.idTask;
    let url = API_CONFIG.casaideas + "/externalapi/execute/getorderById";

    await axios({
        
      url: url,
      method: "post",
      data: {
        username: casaideas_credentials.user,
        password: casaideas_credentials.password,
        order_id: order_id,
        customer_id: customer_id,
        adminpath: "matrix",
      },
    })
      .then((response) => response.data)
      .then((data) => {
        var arr = [];
        var arr2 = [];
        var i = 0;
        if (data.success) {
          data = {
            resp: "OK",
            rows: data.response[0].products,
          };
        }
        if (data.resp === "OK" && data.rows.length > 0) {
          if (pedido_parcial === "SI") {
            for (let k in mixed_skus) {
              let sku = mixed_skus[k];
              //console.log("sku original ", sku.sku)

              let isValid = false;
              for (let m in data.rows) {
                let key = data.rows[m];
                if (sku.sku === key.sku) {
                  if (flowcode === "flowBolCI07") {
                    //console.log("tienda online", sku.sku , key.sku , officecode , sku.store)
                    //pickup del restante de la otra tienda
                    if (officecode !== sku.store) {
                      arr.push({
                        id: key,
                        product_id: key.product_id,
                        productName: key.name,
                        productModel: key.model,
                        productPrice: key.price,
                        productQty: key.quantity,
                        productImage: key.image,
                        productSKU: key.sku,
                        state: "loaded",
                      });
                    } else {
                      arr2.push({
                        id: key,
                        product_id: key.product_id,
                        productName: key.name,
                        productModel: key.model,
                        productPrice: key.price,
                        productQty: key.quantity,
                        productImage: key.image,
                        productSKU: key.sku,
                        state: "loaded",
                      });
                    }
                  } else {
                    //console.log("tienda no online")
                    //es la tienda original
                    if (officecode === sku.store) {
                      arr.push({
                        id: key,
                        product_id: key.product_id,
                        productName: key.name,
                        productModel: key.model,
                        productPrice: key.price,
                        productQty: key.quantity,
                        productImage: key.image,
                        productSKU: key.sku,
                        state: "loaded",
                      });
                    } else {
                      arr2.push({
                        id: key,
                        product_id: key.product_id,
                        productName: key.name,
                        productModel: key.model,
                        productPrice: key.price,
                        productQty: key.quantity,
                        productImage: key.image,
                        productSKU: key.sku,
                        state: "loaded",
                      });
                    }
                  }
                }
              }
            }
          } else {
            for (let key in data.rows) {
              arr.push({
                id: key,
                product_id: data.rows[key].product_id,
                productName: data.rows[key].name,
                productModel: data.rows[key].model,
                productPrice: data.rows[key].price,
                productQty: data.rows[key].quantity,
                productImage: data.rows[key].image,
                productSKU: data.rows[key].sku,
                state: "loaded",
              });
            }
          }
        }

        this.setState({
          ...this.state,
          orders: arr,
          orders2: arr2,
          isLoadedTable: true,
          customerName: nombre_cliente,
          customerAdd: direccion_1,
          customerZone: zona,
          customer_id: customer_id,
          loadingData: false,
          existingPreviousOrder: false /*revisar*/,
          isDeleted: false /*revisar*/,
          order_id: order_id /*revisar*/,
        });
      });
  };

  toggleModal = (nr) => () => {
    let modalNumber = "modal" + nr;
    this.setState({
      [modalNumber]: !this.state[modalNumber],
    });
  };

  executeTask = async (option, optionName) => {
    var responseValidation = true;

    var f = new Date(this.state.from_date);
    var fecha =
      (f.getDate() < 10 ? "0" + f.getDate() : f.getDate()) +
      "/" +
      (f.getMonth() + 1 < 10 ? "0" + (f.getMonth() + 1) : f.getMonth() + 1) +
      "/" +
      (f.getFullYear() + "");

    console.log(fecha, option, optionName, this.state.formButtons.length);
    //var fecha = res [2]+"/"+res[1]+"/"+res[0]
    this.setState({ isExecuting: true });

    var monto_real = this.state.monto_real;
    var monto_2 = this.state.monto_2;
    var metodo_pago = this.state.metodo_pago;
    var metodo_pago_2 = this.state.metodo_pago_2;
    var motivo_no_entrega = this.state.motivo_no_entrega;
    //console.log(this.state.formButtons.buttonsList)

    if (optionName == "No entregado" && this.state.formButtons.length > 1) {
      if (motivo_no_entrega == "") {
        var msj_validacion = "Seleccione el motivo de no Entrega";
        toast.warning(msj_validacion, {
          closeButton: true,
        });
        responseValidation = false;
      }
    } else {
      motivo_no_entrega = "";
      if (this.state.numero_factura === "" && this.state.validaFactura) {
        responseValidation = false;
        toast.warning("Debe completar la factura", { closeButton: true });
      }
      if (this.state.razon_social === "" && this.state.validaFactura) {
        responseValidation = false;
        toast.warning("Debe completar la razon social", { closeButton: true });
      }

      if (metodo_pago == "") {
        var msj_validacion = "Seleccion el campo metodo de pago";
        toast.warning(msj_validacion, {
          closeButton: true,
        });
        responseValidation = false;
      }

      if (monto_real == "") {
        var msj_validacion = "Complete el campo monto pagado";
        toast.warning(msj_validacion, {
          closeButton: true,
        });
        responseValidation = false;
      } else {
        if (isNaN(monto_real)) {
          var msj_validacion = "El campo monto pagado debe ser numero";
          toast.warning(msj_validacion, {
            closeButton: true,
          });
          responseValidation = false;
        }
      }
      if (metodo_pago_2 != "") {
        if (monto_2 == "") {
          var msj_validacion = "Complete el campo monto pagado 2";
          toast.warning(msj_validacion, {
            closeButton: true,
          });
          responseValidation = false;
        } else {
          if (isNaN(monto_2)) {
            var msj_validacion = "El campo monto pagado 2 debe ser numero";
            toast.warning(msj_validacion, {
              closeButton: true,
            });
            responseValidation = false;
          }
        }
      }
    }

    if (!responseValidation) {
      this.setState({
        ...this.state,
        responseTask: "NOK",
        isExecuting: false,
        modal6: false,
      });
    } else {
      this.setState({ responseTask: null });

      var params = {
        comment_entrega: this.state.observation,
        fecha_pago: fecha,
        monto_real: this.state.monto_real,
        monto_2: this.state.monto_2,
        metodo_pago: this.state.metodo_pago,
        metodo_pago_2: this.state.metodo_pago_2,
        motivo_no_entrega: motivo_no_entrega,

        TRX: this.state.TRX,
        numero_factura: this.state.numero_factura,
      };

      await axios({
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.state.token,
        },
        url: API_CONFIG.xflowurl + "/engine-users/execute-task",
        //url : "http://localhost:4042/api/v1"+"/engine-users/execute-task",
        data: {
          parentid: this.state.WO_TaskId,
          id: this.state.WO_TaskId,
          isParent: this.state.isParent,
          optionValue: optionName,
          params: params,
        },
        method: "put",
      })
        .then((response) => response.data)
        .then((data) => {
          if (data.status) {
            toast.success("Procesado con exito", {
              closeButton: true,
            });

            if (this.state.reload) {
              setTimeout(async function () {
                console.log("popup");
                window.opener.postMessage("TAREA_COMPLETADA", "*");
                window.close();
              }, 1000);
              try {
                //window.opener.location.reload();
              } catch (ex) {
                console.log("error closing");
              }
            } else {
              console.log("dialog");
              setTimeout(async function () {
                window.parent.postMessage("TAREA_COMPLETADA", "*");
              }, 1000);
            }
          } else {
            toast.error("Error ejecutando tareas, mensaje:" + data.message, {
              closeButton: true,
            });
          }
          this.setState({
            ...this.state,
            isExecuting: false,
            modal6: false,
          });
        });
    }
  };

  render() {
    return (
      <>
        {this.state.loadingData ? (
          <Loader idLoading={this.state.loadingData} />
        ) : (
          <>
            <Loader idLoading={this.state.isExecuting} />

            <MDBCard>
              <h3
                style={{
                  zIndex: "1000",
                  fontWeight: "600",
                  color: "#000",
                }}
              >
                {" "}
                {"Pedido #" + this.state.order_id}
              </h3>

              <MDBRow>
                <MDBCol size="12" sm="6" md="3" lg="2">
                  SubTotal
                </MDBCol>
                <MDBCol
                  size="12"
                  sm="6"
                  md="3"
                  lg="2"
                  xl="2"
                  className="text-right"
                >
                  <h6
                    style={{
                      zIndex: "1000",
                      fontWeight: "400",
                      color: "#000",
                    }}
                  >
                    {" "}
                    {this.state.sub_total + " Bs."}
                  </h6>{" "}
                </MDBCol>
              </MDBRow>
              <MDBRow>
                <MDBCol size="12" sm="6" md="3" lg="2">
                  Descuento
                </MDBCol>
                <MDBCol
                  size="12"
                  sm="6"
                  md="3"
                  lg="2"
                  xl="2"
                  className="text-right"
                >
                  <h6
                    style={{
                      zIndex: "1000",
                      fontWeight: "400",
                      color: "#000",
                    }}
                  >
                    {" "}
                    {this.state.descuento + " Bs."}
                  </h6>{" "}
                </MDBCol>
              </MDBRow>

              <MDBRow>
                <MDBCol size="12" sm="6" md="3" lg="2">
                  Costo de Envio
                </MDBCol>
                <MDBCol
                  size="12"
                  sm="6"
                  md="3"
                  lg="2"
                  xl="2"
                  className="text-right"
                >
                  <h6
                    style={{
                      zIndex: "1000",
                      fontWeight: "400",
                      color: "#000",
                    }}
                  >
                    {" "}
                    {this.state.costo_envio + " Bs."}
                  </h6>{" "}
                </MDBCol>
              </MDBRow>

              <MDBRow>
                <MDBCol size="12" sm="6" md="3" lg="2">
                  {" "}
                  <h5
                    style={{
                      zIndex: "1000",
                      fontWeight: "500",
                      color: "#000",
                    }}
                  >
                    {" "}
                    Total:
                  </h5>
                </MDBCol>
                <MDBCol
                  size="12"
                  sm="6"
                  md="3"
                  lg="2"
                  xl="2"
                  className="text-right"
                >
                  {" "}
                  <h5
                    style={{
                      zIndex: "1000",
                      fontWeight: "500",
                      color: "#000",
                    }}
                  >
                    {" "}
                    {this.state.monto_total + " Bs."}
                  </h5>
                </MDBCol>
              </MDBRow>

              <MDBRow>
                <MDBCol size="12" className="text-left">
                  <h4
                    style={{
                      zIndex: "1000",
                      fontWeight: "400",
                      color: "#000",
                    }}
                  >
                    {" "}
                    Detalle de la orden{" "}
                  </h4>
                </MDBCol>
              </MDBRow>

              {this.state.orders.map((event) => (
                <p
                  className="ml-1"
                  key={"event1" + event.id}
                  style={{ width: "98%" }}
                >
                  <Event
                    id={event.id}
                    product_id={".000" + event.product_id}
                    productName={event.productName}
                    productQty={event.productQty}
                    productPrice={event.productPrice}
                    productModel={event.productModel}
                    productImage={event.productImage}
                    productSKU={event.productSKU}
                    state={event.state}
                    onDelete={null}
                    onEdit={null}
                    onPick={this.handlePick}
                  />
                </p>
              ))}

              {this.state.validaFactura && (
                <MDBRow className="ml-1" style={{ width: "99%" }}>
                  <MDBCol
                    size="12"
                    sm="6"
                    md="6"
                    lg="6"
                    xl="6"
                    className="text-right mt-4"
                  >
                    <MDBInput
                      style={{ margin: "0" }}
                      id={"TRX"}
                      key={"TRX"}
                      name={"TRX"}
                      value={this.state.TRX}
                      onChange={this.changeHandler}
                      size="sm"
                      label="TRX"
                    />
                  </MDBCol>

                  <MDBCol
                    size="12"
                    sm="6"
                    md="6"
                    lg="6"
                    xl="6"
                    className="text-right mt-4"
                  >
                    <MDBInput
                      style={{ margin: "0" }}
                      id={"numero_factura"}
                      key={"numero_factura"}
                      name={"numero_factura"}
                      value={this.state.numero_factura}
                      onChange={this.changeHandler}
                      size="sm"
                      label="Número Factura"
                    />
                  </MDBCol>

                  <MDBCol
                    size="12"
                    sm="6"
                    md="6"
                    lg="6"
                    xl="6"
                    className="text-right mt-4"
                  >
                    <MDBInput
                      style={{ margin: "0" }}
                      id={"razon_social"}
                      key={"razon_social"}
                      name={"razon_social"}
                      value={this.state.razon_social}
                      onChange={this.changeHandler}
                      size="sm"
                      label="Razón Social"
                    />
                  </MDBCol>

                  <MDBCol
                    size="12"
                    sm="6"
                    md="6"
                    lg="6"
                    xl="6"
                    className="text-right mt-4"
                  >
                    <MDBBtn
                      style={{ marginLeft: "-40px" }}
                      size="sm"
                      color="primary"
                      disabled={this.state.readOnly}
                      onClick={this.saveInoiceData}
                    >
                      {" "}
                      Guardar Datos
                    </MDBBtn>
                  </MDBCol>
                </MDBRow>
              )}

              <MDBRow className="ml-1" style={{ width: "99%" }}>
                <MDBCol sm="12" md="9" lg="6" className="text-left">
                  <span style={{ color: "#909090" }}> Fecha de pago </span>{" "}
                  <MDBDatePicker
                    style={{ marginTop: "-1.5rem" }}
                    key="from"
                    name="from"
                    id="from"
                    format="DD/MM/YYYY"
                    value={this.state.from_date}
                    cancelLabel="Cancelar"
                    getValue={this.getPickerValueFrom}
                  />
                </MDBCol>
              </MDBRow>

              <MDBRow className="ml-1">
                <MDBCol sm="12" md="6" lg="6" className=" text-left left">
                  <MDBSelect
                    className="is-invalid"
                    key="metodo_pago"
                    id="metodo_pago"
                    color="primary"
                    getValue={this.selectHandler1}
                    options={this.state.metodos}
                    label="M&eacute;todo de Pago"
                  />
                </MDBCol>
                <MDBCol sm="12" md="6" lg="6" className=" text-left left">
                  <MDBInput
                    name="monto_real"
                    onChange={this.changeHandler}
                    type="text"
                    id="monto_real"
                    key="monto_real"
                    value={this.state.monto_real}
                    label="Monto Pagado"
                    required
                  ></MDBInput>
                </MDBCol>
                <MDBCol sm="12" md="6" lg="6" className=" text-left left">
                  <MDBSelect
                    className="is-invalid"
                    key="metodo_pago_2"
                    id="metodo_pago_2"
                    color="primary"
                    getValue={this.selectHandler2}
                    options={this.state.metodos2}
                    label="Metodo de Pago 2"
                  />
                </MDBCol>
                <MDBCol sm="12" md="6" lg="6" className=" text-left left">
                  <MDBInput
                    name="monto_2"
                    onChange={this.changeHandler}
                    type="text"
                    id="monto_2"
                    key="monto_2"
                    disabled={this.state.metodo_pago_2 == "" ? true : false}
                    value={this.state.monto_2}
                    label="Monto pagado 2"
                    required
                  ></MDBInput>
                </MDBCol>
                <MDBCol sm="12" md="6" lg="6" className=" text-left left">
                  <MDBSelect
                    className="is-invalid"
                    key="store"
                    id="store"
                    color="primary"
                    getValue={this.selectHandler3}
                    options={this.state.motivos}
                    label="Motivo no Entrega"
                  />
                </MDBCol>
              </MDBRow>

              <MDBRow style={{ marginTop: "-1.5rem" }}>
                <MDBCol sm="12" md="12" lg="12" className="text-left left">
                  <MDBInput
                    type="textarea"
                    id="observation"
                    label="Comentario Adicional"
                    rows="2"
                    name="observation"
                    key="observation"
                    value={this.state.observation}
                    onChange={this.changeHandler}
                    icon="pencil-alt"
                  />
                </MDBCol>
              </MDBRow>
              <MDBRow
                className="text-right"
                style={{ marginTop: 15, marginBottom: 15 }}
              >
                <MDBCol md="12">
                  {this.state.formButtons.map((item) => (
                    <MDBBtn
                      color="primary"
                      size="sm"
                      onClick={() => {
                        this.setState({
                          modal6: true,
                          optionMessage:
                            "Confirma la opcion " + item.optionname + "?",
                          optionCode: item.optioncode,
                          optionName: item.optionname,
                        });
                      }}
                      key={item.optioncode}
                    >
                      {" "}
                      {item.optionname}
                    </MDBBtn>
                  ))}
                </MDBCol>
              </MDBRow>
            </MDBCard>
          </>
        )}

        <MDBModal
          cascading
          centered
          isOpen={this.state.modal6}
          toggle={this.toggleModal(6)}
          size="md"
        >
          <MDBModalBody className="text-center">
            <span className="h4-responsive text-center text-uppercase">
              {" "}
              {this.state.optionMessage}
            </span>
            <hr />
            <MDBRow className="text-center">
              <MDBCol md="12">
                <MDBBtnGroup size="sm">
                  <MDBBtn
                    outline
                    onClick={() => {
                      this.setState({ modal6: false });
                    }}
                    color="warning"
                  >
                    {" "}
                    <span className="h4-responsive">Cancelar</span>
                  </MDBBtn>
                  <MDBBtn
                    onClick={() => {
                      this.setState({ modal6: false });
                      this.executeTask(
                        this.state.optionCode,
                        this.state.optionName
                      );
                    }}
                    color="primary"
                  >
                    {" "}
                    <span className="h5-responsive">Aceptar</span>{" "}
                  </MDBBtn>
                </MDBBtnGroup>
              </MDBCol>
            </MDBRow>
          </MDBModalBody>
        </MDBModal>

        <ToastContainer
          hideProgressBar={true}
          newestOnTop={false}
          position={"bottom-right"}
          autoClose={3000}
        />
      </>
    );
  }
}

class Event extends React.Component {
  render() {
    return this.props.state === "deleting" ? (
      <MDBCard
        style={{
          opacity: "0.4",
          backgroundColor: "#999",
        }}
        className="align-items-center justify-content-center"
      >
        <p></p>
        <div className="media mt-4 align-middle">
          <div className="media-body mb-3 mb-lg-3">
            <MDBAnimation type="rotateOut" infinite>
              <MDBIcon
                style={{
                  zIndex: "1050",
                }}
                size="2x"
                far
                icon="trash-alt"
              />
            </MDBAnimation>
          </div>
        </div>
        <p></p>
      </MDBCard>
    ) : (
      <MDBCard className="">
        <div className="media mt-1">
          <span className="h4-responsive font-weight-bold mr-3 align-items-right justify-content-right">
            {this.props.productQty}
            <br />

            <img
              src={this.props.productImage}
              alt="thumbnail"
              height="60px"
              width="60px"
              className="img-thumbnail"
            />
          </span>
          <div className="media-body mb-3 mb-lg-3">
            <span className="h6 mt-0 font-weight-bold">
              {this.props.productName}{" "}
            </span>{" "}
            <hr className="hr-bold my-2" />
            {this.props.product_id && (
              <React.Fragment>
                <p className="font-smaller mb-0">
                  <MDBRow className="align-items-left justify-content-left">
                    <MDBCol md="12">
                      <MDBIcon icon="shopping-basket" /> Codigo:{" "}
                      {this.props.productModel}
                    </MDBCol>
                  </MDBRow>
                  <MDBRow className="align-items-left justify-content-left">
                    <MDBCol md="12">
                      <MDBIcon icon="barcode" /> SKU: {this.props.productSKU}
                    </MDBCol>
                  </MDBRow>
                </p>
              </React.Fragment>
            )}
          </div>
        </div>
        {this.props.productQty && (
          <p className="p-2 mb-4  blue-grey lighten-5 blue-grey lighten-5">
            {"Cantidad: " +
              this.props.productQty +
              ", Precio unitario: " +
              this.props.productPrice +
              ", Total " +
              parseInt(this.props.productPrice.replace("Bs.", "")) *
                parseInt(this.props.productQty) +
              "Bs."}
          </p>
        )}
      </MDBCard>
    );
  }
}

export default externalForm02;
